import { UserResource } from "types";

export const isClient = (user?: UserResource) => {
  return user?.userableType === "client";
};

export const isPersonnel = (user?: UserResource) => {
  return user?.userableType === "personnel";
};
